
import {Fetch} from "../../utils/storage"
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"


export default {
name: 'Order-detail',
components: {
XInput,
XButton,
Group,
Divider,
Cell,
CellBox,
Popup,
Checklist
},
filters: {
/**
* @return {string}
*/
MeetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
},
InvoiceTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.InvoiceEndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
}
},
data () {
return {
ApplyReq:{},
Meeting:{},
SubMeeting:{},
Order:{},
OrderIDs:[],
OrderInfo:{},
HotelOrder:{},
MeetingID: 0,
OrderList:[],
OrderID:0,
UserID:0,
HasHotel: true,
ChosenHotel:[],
HotelForm:{
CheckInAt:[],
CheckOutAt:[]
},

InvoiceInfoList: [],
InvoiceInfoOptions:[],
ChosenInvoiceInfo: [],
DefaultInvoiceInfoIndex:0,
ShowInvoiceInfoPop: false,
InvoiceInfo: {},
}
},
created () {
this.OrderIDs = this.$route.query["orderIDs"]
if (!this.OrderIDs) this.$router.go(-1)
this.OrderIDs = JSON.parse(this.OrderIDs)
this.MeetingID = parseInt(this.$route.query["MeetingID"])
this.UserID = Fetch("ID")
this.fetchOrderList()
this.fetchMeetingDetailWithID()
this.fetchInvoiceInfoList()
},
methods: {
ParseTime,
async fetchOrderList() {
let res = await Api('GetOrderList',{
IDs:this.OrderIDs,
Preloads:[
{Column:'OrderInfo'},
]
})
if (res.data.List && res.data.List.length > 0) {
this.OrderList = res.data.List
console.log(this.OrderList)

} else {
this.$vux.toast.show({
text:'获取订单信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
async fetchMeetingDetailWithID() {
let id = this.MeetingID
let res = await Api('GetMeetingList',{
Data: {
ID:id,
}
})
if (res.data.List && res.data.List.length == 1) {
this.Meeting = res.data.List[0]
console.log(this.Meeting)
} else {
console.log(res)
this.$vux.toast.show({
text:'获取会议信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
async fetchInvoiceInfoList() {
let res = await Api('GetInvoiceInfoList',{
Data:{
UserID:this.UserID,
},
Limit:999,
})
this.InvoiceInfoList = res.data.List || []
this.InvoiceInfoOptions = this.InvoiceInfoList.map((value,index) =>{
if(value.Default) {
this.DefaultInvoiceInfoIndex = index+1
this.ChosenInvoiceInfo = [index+1]
}
return {
key: index+1,
value: value.Title,
inlineDesc: `${value.TaxNumber}---${value.Email || '暂无'}`
}
})
},
handleInvoiceInfoSubmit() {
if(this.ChosenInvoiceInfo.length < 1) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">您还没选择发票抬头！</span>',
showCancelButton:false,
})
return
}
this.ShowInvoiceInfoPop = !this.ShowInvoiceInfoPop
this.ApplyReq.InvoiceTitle = this.InvoiceInfo.Title
this.ApplyReq.InvoiceNum =  this.InvoiceInfo.TaxNumber
this.ApplyReq.Email = this.InvoiceInfo.Email
if (!this.ApplyReq.Emacr) {
this.$vux.toast.show({
text:'发票邮箱为空，请填写接受邮箱！！',
type:'cancel',
})
this.$refs.emailAddInput.focus()
}
},
handleInvoiceInfoPopCancel() {
this.ChosenInvoiceInfo = [this.DefaultInvoiceInfoIndex]
this.ShowInvoiceInfoPop = !this.ShowInvoiceInfoPop
},
handleInvoiceInfoPopAdd() {
this.$router.push('/user/invoice-info/new')
},
handleInvoiceInfoChange(val) {
this.InvoiceInfo = this.InvoiceInfoList[val-1]
},
handleSubmit() {

let _this = this
if (
!this.ApplyReq.InvoiceNum ||
this.ApplyReq.InvoiceNum.length < 15) {
this.$vux.toast.show({
text: '发票税号不可为空，且不得少于15位！',
type: 'text',
width:'3rem'
})
return
}
if (
!this.ApplyReq.InvoiceTitle) {
this.$vux.toast.show({
text: '发票税号不可为空',
type: 'text',
width:'3rem'
})
return
}

if (!this.ApplyReq.Email) {
this.$vux.toast.show({
text: '发票接受邮箱不可为空！',
type: 'text',
width:'3rem'
})
this.$refs.emailAddInput.focus()
return
}
console.log(this.$refs.emailAddInput.valid)
if (!this.$refs.emailAddInput.valid) {
this.$vux.toast.show({
text: '发票接受邮箱格式错误！',
type: 'text',
width:'3rem'
})
this.$refs.emailAddInput.focus()
return
}

let diff = new Date(_this.Meeting.StartAt).getTime() - new Date().getTime()
let diff1 = new Date().getTime() - new Date(_this.Meeting.InvoiceEndAt).getTime()
if (diff > 0 || diff1 > 0) {
_this.$vux.toast.show({
text: '现在不在可开取发票的时段！',
type: 'text',
width: '3.5rem'
})
return
}

this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">请确认发票接收邮箱、发票信息正确，如填写错误，将影响发票开取！！！</span>`,
confirmText:"我已确认",
cancelText:"取消",

async onConfirm(){
try {
_this.ApplyReq.OrderIDs = _this.OrderIDs
let res = await Api('InvoiceApplyYongyou', _this.ApplyReq)
if (res.data.Message != 'success') {
throw Error(res.data.Message)
}
_this.$vux.toast.show({
text: '发起开票成功，发票将会发送至您邮箱！',
type: 'text',
width: '3rem'
})
_this.$router.go(-1)
} catch (err) {
_this.$vux.toast.show({
text: `发起开票请求失败：${err.message}`,
type: 'text',
width: '3rem'
})

}
}
})

},
},
}
